<template>
	<div class="tcContent">
		<div class="cardInner">
			<div class="rowCard" style="max-height: 36%;margin-bottom: 2%;">
				<div class="calCard tCard" style="width: 217px;height: 100%;">
					<div class="card">
						<i></i> <i></i> <i></i> <i></i>
						<div class="cardTitle">
							<span>冷源</span>
							<p>单位：千瓦时（kw·h）</p>
						</div>
						<div class="echart" id="chart1" ref="chart1"></div>
						
					</div>
				</div>
				<div style="width: 25px;"></div>
				<div class="calCard tCard" style="width: 217px;height: 100%;">
					<div class="card">
						<i></i> <i></i> <i></i> <i></i>
						
						<div class="cardTitle">
							<span>热源</span>
							<p>单位：千瓦时（kw·h）</p>
						</div>
						<div class="echart" id="chart2" ref="chart2"></div>
					</div>
				</div>
			</div>
			
			<div class="rowCardInner">
				<div class="card card1">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>用电</span>
						<p>单位：千瓦时（kw · h）</p>
					</div>
					<div class="echart" id="chart3" ref="chart3"></div>
				</div>
				<div class="card card2">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<div class="cardTitleInner">
							<img src="@/assets/fx.png" alt="" srcset="" />
							<span>用电数据分析</span>
						</div>
					</div>
					<div class="fpView">
						<div class="fpViewItem">
							<span>当日用电总量（kw）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>2</span></div>
									<div><span>3</span></div>
								</div>
								<p>
									同比增长
									<span>11.3% ▲</span>
								</p>
							</div>
						</div>
						<div class="fpViewItem">
							<span>当月用电总量（kw）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>3</span></div>
									<div><span>2</span></div>
									<div><span>3</span></div>
								</div>
								<p>
									同比增长
									<span>13.3% ▲</span>
								</p>
							</div>
						</div>
						<div class="fpViewItem">
							<span>当年用电总量（kw）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>2</span></div>
									<div><span>8</span></div>
									<div><span>4</span></div>
									<div><span>3</span></div>
								</div>
								<p>
									同比增长
									<span>10.3% ▲</span>
								</p>
							</div>
						</div>
						
					</div>
				</div>
			</div>
			<div class="rowCardInner">
				<div class="card card1">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>用水</span>
						<p>单位：吨（t）</p>
					</div>
					<div class="echart" id="chart5" ref="chart5"></div>
				</div>
				<div class="card card2">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<div class="cardTitleInner">
							<img src="@/assets/fx.png" alt="" srcset="" />
							<span>用水数据分析</span>
						</div>
					</div>
					<div class="fpView">
						<div class="fpViewItem">
							<span>当日用水总量（t）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>1</span></div>
									<div><span>5</span></div>
								</div>
								<p>
									同比增长
									<span>12.3% ▲</span>
								</p>
							</div>
						</div>
						<div class="fpViewItem">
							<span>当月用水总量（t）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>0</span></div>
									<div><span>2</span></div>
									<div><span>5</span></div>
									<div><span>9</span></div>
								</div>
								<p>
									同比增长
									<span>9.3% ▲</span>
								</p>
							</div>
						</div>
						<div class="fpViewItem">
							<span>当年用水总量（t）</span>
							<div class="b">
								<div class="l">
									<div><span>0</span></div>
									<div><span>3</span></div>
									<div><span>8</span></div>
									<div><span>2</span></div>
									<div><span>9</span></div>
								</div>
								<p>
									同比增长
									<span>8.3% ▲</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="calCardInner">
				<div class="card">
					<i></i> <i></i> <i></i> <i></i>
					<div class="cardTitle">
						<span>天然气锅炉房使用情况</span>
						<p>单位：标准立方米（Nm³）</p>
					</div>
					<div class="echart" id="chart4" ref="chart4"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		chart1,
		chart2,
		chart3,
		chart4,
		chart5
	} from '../common/nyoptions.js';
	import * as echarts from 'echarts';
	export default {
		name: 'HelloWorld',
		data(){
			return {
				chart1: null,
				chart2: null,
				chart3: null,
				chart4: null,
				chart5: null
			}
		},
		created() {
			this.$nextTick(_ => {
				this.setChart();
			})
			let _self = this;
			window.addEventListener('resize', function() {
				clearTimeout(_self.timer)
				_self.timer = setTimeout(_ => {
					_self.resize()
				}, 1000)
			})
		},
		methods:{
			resize() {
				this.chart1.resize();
				this.chart2.resize();
				this.chart3.resize();
				this.chart4.resize();
				this.chart5.resize();
			},
			setChart(){
				this.chart1 = echarts.init(this.$refs.chart1);
				this.chart1.setOption(chart1);
				
				this.chart2 = echarts.init(this.$refs.chart2);
				this.chart2.setOption(chart2);
				
				this.chart3 = echarts.init(this.$refs.chart3);
				this.chart3.setOption(chart3);
				
				this.chart4 = echarts.init(this.$refs.chart4);
				this.chart4.setOption(chart4);
				
				this.chart5 = echarts.init(this.$refs.chart5);
				this.chart5.setOption(chart5);
			}
		}
	}
</script>

<style scoped>
	div {
		font-size: 12px;
		line-height: 1.8;
		/* #ifndef APP */
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		/* #endif */
		display: flex;
		flex-direction: column;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.tcContent {
		padding: 12px 20px;
		flex: 1
	}
	
	.cardInner{
		align-self: flex-end;
		align-items: stretch;
		width: 560px;
		flex: 1
	}

	.rowCard {
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		flex: 2;
	}

	.rowCard:last-child {
		padding-bottom: 0;
	}
	.bRowCard .calCard{
		max-width: 20%;
	}
	.bRowCard .card2{
		max-width: 233px;
	}
	.calCardInner{
		height: 18%;
		display: flex;
		flex-direction: row;
	}
	.calCardInner .card{
		flex: 1;
	}
	.rowCardInner{
		width: 100%;
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		max-height: 20%;
		margin-bottom: 2%;
	}
	.rowCardInner .card{
		flex: 1;
	}
	.rowCardInner .card1{
		max-width: 360px;
	}
	.rowCardInner .card2{
		max-width: 200px;
	}
	.calCard {
		flex: 1;
		height: 100%;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	.tCard{
		max-width: 360px;
	}
	.clCalCard{
		width: calc(65% - 30px);
	}
	.yhCard{
		width: 35%;
	}

	.card {
		flex: 1;
		height: 100%;
		border: 1px solid rgba(32, 110, 212, .5);
		background: rgba(32, 110, 212, .1);
		position: relative;
		transition: all .2s;
	}

	.card:hover {
		background: rgba(32, 110, 212, .3);
	}

	.numList {
		max-width: 37% !important;
		min-width: 250px;
		margin-right: -2px;
		z-index: 2;
	}


	.card i {
		display: block;
		position: absolute;
	}
	.cardTitle{
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:first-child {
		top: 0;
		left: 0;
		position: absolute;
	}

	.card i:first-child:before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:first-child::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(2) {
		top: 0;
		right: 9px;
		position: absolute;
	}

	.card i:nth-child(2):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(2)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		right: -9px;
	}

	.card i:nth-child(3) {
		bottom: 9px;
		left: 0;
		position: absolute;
	}

	.card i:nth-child(3):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 7px;
		left: 0;
	}

	.card i:nth-child(3)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 0;
	}

	.card i:nth-child(4) {
		bottom: 9px;
		right: 9px;
		position: absolute;
	}

	.card i:nth-child(4):before {
		content: '';
		display: block;
		width: 9px;
		height: 2px;
		background: #206ED4;
		position: absolute;
		top: 7px;
		left: 0;
	}

	.card i:nth-child(4)::after {
		content: '';
		display: block;
		width: 2px;
		height: 9px;
		background: #206ED4;
		position: absolute;
		top: 0;
		left: 7px;
	}
	
	.echart{
		width: 100%;
		flex: 1;
	}
	
	.viewList{
		flex: 1;
		padding: 0 8px 8px;
	}
	.viewListTh{
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 30px;
		background: #113F73;
	}
	
	.viewListTd{
		flex: 1;
		padding: 0 10px;
		color: #07DBFF;
		white-space: nowrap;
		
	}
	.viewListTd:nth-child(2){
		justify-content: center;
		align-items: center;
	}
	.viewListTd:last-child{
		align-items: flex-end;
	}
	.viewListTr .viewListTd{
		color: #CCC;
	}
	.viewListTr .viewListTd:first-child{
		color: #FFF;
	}
	
	.viewListTr{
		border: 1px solid transparent;
		border-bottom: 1px solid #09718F;
		padding-right: 10px;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		height: 30px;
		position: relative;
	}
	.viewListTr:hover{
		border: 1px solid #07DBFF;
		box-shadow: 0 0 10px 0 #07DBFF inset;
	}
	.viewListTr:hover::after{
		content: '';
		display: block;
		border-top: 4px solid transparent;
		border-right: 6px solid #07DBFF;
		border-bottom: 4px solid transparent;
		border-left: 4px solid transparent;
		position: absolute;
		right: 6px;
	}
	
	
	.viewListTitle{
		font-size: 14px;
		color: #FFF;
		justify-content: center;
		align-items: center;
		height: 36px;
		min-height: 36px;
		letter-spacing: 3px;
		background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 20% , #043D85 36%, #043D85 64%, rgba(0,0,0,0) 80%,  rgba(0,0,0,0) 100%);
	}
	.viewListTitle::after{
		content: '';
		display: flex;
		width: 70%;
		height: 2px;
		background: linear-gradient(to right, rgba(0,0,0,0) 0% ,  rgba(0,0,0,0) 20%,  #31b7ff 30%, #FFF 50%,  #31b7ff 70%,  rgba(0,0,0,0) 80%,  rgba(0,0,0,0) 100%);
	}
	
	
	.cardTitle{
		padding: 6px 10px;
	}
	.cardTitle span{
		color: #FFF;
		font-size: 12px;
	}
	.cardTitle p{
		color: #206ED4;
		font-size: 10px;
	}
	
	.cardTitleInner{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding-top: 6px;
	}
	.cardTitleInner img{
		width: 18px;
		height: 18px;
	}
	.cardTitleInner span{
		font-size: 10px;
		color: #FFF;
		line-height: 14px;
		border-left: 1px solid #FFF;
		margin-left: 8px;
		padding-left: 8px;
	}
	.fpView{
		padding-top: 20%;
		padding-left: 10px;
	}
	.fpViewItem{
		transform: scale(.8,.8);
		/* margin-top: -10px; */
	}
	.fpViewItem:first-child{
		margin-top: -8px;
	}
	.fpViewItem>span{
		font-size: 10px;
		color: #26D1D4;
	}
	.fpViewItem .b{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		/* margin: 10px 0; */
		
	}
	.fpViewItem .b .l{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-right: 8px;
	}
	.fpViewItem .b .l div{
		height: 18px;
		width: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFF;
		font-size: 15px;
		font-weight: bold;
		margin-right: 4px;
		position: relative;
	}
	.fpViewItem .b .l div span{
		z-index: 2;
	}
	.fpViewItem .b .l div::before{
		content: '';
		display: flex;
		background: #224594;
		width: 12px;
		height: 7px;
		position: absolute;
		border-radius: 2px 2px 0 0 ;
		z-index: 1;
		top: 0;
	}
	.fpViewItem .b .l div::after{
		content: '';
		display: flex;
		background: #224594;
		width: 12px;
		height: 7px;
		position: absolute;
		border-radius: 0 0 2px 2px;
		z-index: 1;
		bottom: 0;
	}
	.fpViewItem .b p{
		color: #26D1D4;
		font-size: 10px;
		line-height: 14px;
	}
	.fpViewItem .b p span{
		color: #FFBA63;
	}
	
	
</style>